export default __webpack_public_path__ + "static/media/06.cc851759.png";